<template>
  <div class="app-container fontBold"
       :class="{'leaveList':authType == 1}">
    <div v-if="authType == 2">
      <div class="top_time flex_center_between">
        <div class="fontSize40 ">{{detailInfo.tsCardTime.split(' ')[1]}}</div>
        <div class="fontSize12 marginLeft10 text_r">
          <div class="fontColorGreen">考勤时间</div>
          <div class="marginTop8 ">{{detailInfo.tsCardTime.split(' ')[0]}}</div>
        </div>
      </div>
      <div class="marginTop20 flex_center_center">
        <van-icon name="location"
                  size="20"
                  color="#1ac388" />
        <span class="marginLeft5 fontColorGreen">{{detailInfo.devPlace}}</span>
      </div>
      <div class="padding20 fontSize14">
        <div class="flex_center_center">
          <img :src="'manage/' + detailInfo.photoPath"
               class='img_'
               alt="">
        </div>
        <div class="detail_ ">
          <div>
            <span class="fontColorGreen">姓名：</span>{{detailInfo.displayName}}
          </div>
          <div class="marginTop15">
            <span class="fontColorGreen">班级：</span>{{detailInfo.branchName}}
          </div>
          <div class="marginTop15">
            <span class="fontColorGreen">时段：</span>{{periodName}}
          </div>
          <div class="marginTop15">
            <span class="fontColorGreen">体温：</span>{{detailInfo.animalHeat ? detailInfo.animalHeat : '--'}}
          </div>

        </div>
      </div>

    </div>
    <div v-if="authType == 1">
      <div class="top">{{leaveList[0].gradeName + leaveList[0].className}}当天通行记录</div>
      <div v-for="item in leaveList"
           class="leaveItem marginTop10">
        <div>
          <span class="fontColorGreen">姓名：</span>{{item.disName}}
        </div>
        <div>
          <span class="fontColorGreen">离校时间：</span>{{item.leaveDate}}
        </div>
        <div>
          <span class="fontColorGreen">班主任：</span>{{item.headTeacherName}}
        </div>
        <div>
          <span class="fontColorGreen">申请人：</span>{{item.applyUserName}}
        </div>
        <div class="flex_start">
          <span class="fontColorGreen">请假事由：</span>
          <span class="flex1">
            {{item.applyUserName}}
          </span>
        </div>
      </div>
    </div>
    <div class="marginTop40 text_c">
      <van-button type="primary"
                  size="small"
                  class=" fontSize14 "
                  style="width:130px;height:40px"
                  @click="close">确&nbsp;&nbsp;&nbsp;定
      </van-button>
    </div>

  </div>
</template>

<script>
import { getAttendanceDetail, getClassSchoolLeaveMsgList } from '@/api'
import {
  getUrlParamsCode
} from '@/utils/'
export default {
  data () {
    return {
      baseUrl: '',
      id: '',
      detailInfo: {},
      periodName: '',
      authType: '',
      leaveList: []
    }
  },
  created () {
    console.log(process.env)
    const url = decodeURI(window.location.href)
    console.log(url)
    this.authType = decodeURI(getUrlParamsCode(url).authType)
    this.id = decodeURI(getUrlParamsCode(url).businessId)
    if (this.authType == 2) {
      this.periodName = decodeURI(getUrlParamsCode(url).name)
      this.getAttendanceDetail()
    } else {
      this.getClassSchoolLeaveMsgList()
    }

  },
  methods: {
    getAttendanceDetail () {
      getAttendanceDetail({
        id: this.id
      }).then(res => {
        if (res.code === 200) {
          this.detailInfo = res.data
        }
      })
    },
    getClassSchoolLeaveMsgList () {
      getClassSchoolLeaveMsgList({
        classId: this.id
      }).then(res => {
        if (res.code == 200) {
          this.leaveList = res.data
        }
      })
    },
    close () {
      WeixinJSBridge.call('closeWindow')
    }
  }
}
</script>

<style lang='less' scoped>
.detail_ {
  width: fit-content;
  margin: 20px auto 0;
}
.top_time {
  margin: 40px auto 0;
  width: 200px;
}
.img_ {
  width: 200px;
  height: 240px;
  border-radius: 5px;
  box-shadow: 0 0 15px rgba(180, 178, 178);
}
.leaveList {
  height: 100%;
  width: 100%;
  background-color: #f2f2f2;
  padding: 10px;
  .top {
    padding: 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 5px 5px 5px rgb(209, 209, 209);
  }
  .leaveItem {
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 5px 5px 5px rgb(209, 209, 209);
    line-height: 30px;
    font-size: 14px;
  }
}
</style>